import { atom } from "recoil"

export const activeArticleTableRowState = atom<number>({
  key: "activeArticleTableRow",
  default: -1,
})
